import { Form, Input, InputNumber, Radio } from "antd";
import { useEffect } from "react";

export default function AiInfoFrom({ form, item }: any) {
    useEffect(() => {
        if (item.id) {
            form.setFieldsValue(item);
        }
    }, []);

    return (
        <Form form={form} size="small" name="AiInfoFrom" className='ai-info-form' labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} autoComplete="off">
            <Form.Item label="模型名称" name="name" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入模型名称" />
            </Form.Item>
            <Form.Item label="模型备案号" name="recordNumber" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入模型备案号" />
            </Form.Item>
            <Form.Item label="排序" name="sort" rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入排序" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="审核状态" name="status" initialValue={'ENABLE'} rules={[{ required: true, message: '不能为空' }]}>
                <Radio.Group>
                    <Radio value={'DISABLE'}>停用</Radio>
                    <Radio value={'ENABLE'}>启用</Radio>
                </Radio.Group>
            </Form.Item>
        </Form>
    )
}